/** @format */

import { PriceComponent, SizeChartComponent } from '@pdp/components';
import { AttributeLabelComponent } from '../attribute-label/attribute-label.component';
import { AttributesComponent } from './attributes.component';
import { ColorAttributesComponent } from '../color-attributes/color-attributes.component';
import { ColorAttributesPanelModule } from '../color-attributes-panel/color-attributes-panel.module';
import { CommonModule } from '@angular/common';
import { ConfigAttributesPanelComponent } from '../config-attributes-panel/config-attributes-panel.component';
import { NgModule } from '@angular/core';
import { PersonalizationModule } from '../personalization/personalization.module';
import { ProductRecommendationsComponent } from '@shared/components';
import { SelectorAttributesComponent } from '../selector-attributes/selector-attributes.component';
import { SizeAttributesPanelModule } from '../size-attributes-panel/size-attributes-panel.module';
import { TextColorAttributeComponent } from '../text-color-attributes/text-color-attribute.component';
import { HmfAlertBannerComponent } from '@dsg-tech/homefield-angular';

@NgModule({
	imports: [
		AttributeLabelComponent,
		ColorAttributesComponent,
		ColorAttributesPanelModule,
		CommonModule,
		ConfigAttributesPanelComponent,
		HmfAlertBannerComponent,
		PersonalizationModule,
		PriceComponent,
		ProductRecommendationsComponent,
		SelectorAttributesComponent,
		SizeAttributesPanelModule,
		SizeChartComponent,
		TextColorAttributeComponent
	],
	declarations: [AttributesComponent],
	exports: [AttributesComponent]
})
export class AttributesModule {}
